import { EProxyPayType, IPageParam } from '@core/main/types';

/**
 * 风险等级
 */
export enum ERiskWaningLevel {
  /** 低风险 */
  LOW = 'LOW',
  /** 中风险 */
  MEDIUM = 'MEDIUM',
  /** 高风险 */
  HIGH = 'HIGH',
}

export const riskWaningLevelLabel = {
  [ERiskWaningLevel.LOW]: '低风险',
  [ERiskWaningLevel.MEDIUM]: '中风险',
  [ERiskWaningLevel.HIGH]: '高风险',
};

export const riskWaningLevelStyle = {
  [ERiskWaningLevel.LOW]: 'info',
  [ERiskWaningLevel.MEDIUM]: 'primary',
  [ERiskWaningLevel.HIGH]: 'danger',
};

/**
 * 预警状态
 */
export enum ERiskWaningStatus {
  /** 未处理 */
  UN_HANDLED = 0,
  /** 已解决 */
  SOLVED = 1,
  /** 误报 */
  FALSE_ALARM = 2,
}

export const riskWaningStatusLabel = {
  [ERiskWaningStatus.UN_HANDLED]: '未处理',
  [ERiskWaningStatus.SOLVED]: '已解决',
  [ERiskWaningStatus.FALSE_ALARM]: '误报',
};

export const riskWaningStatusStyle = {
  [ERiskWaningStatus.UN_HANDLED]: 'primary',
  [ERiskWaningStatus.SOLVED]: 'success',
  [ERiskWaningStatus.FALSE_ALARM]: 'info',
};

/**
 * 预警类型
 */
export enum ERiskWaningType {
  /** 多企业发放集中 */
  MULTI_COMPANY_ISSUE = 'CENTRALIZE_PAID',
  /** 黑名单登录 */
  BLACKLIST_LOGIN = 'LOGIN',
}

export const riskWaningTypeLabel = {
  [ERiskWaningType.MULTI_COMPANY_ISSUE]: '多企业发放集中',
  [ERiskWaningType.BLACKLIST_LOGIN]: '黑名单登录',
};

export interface IRiskWarningParams extends IPageParam {
  /** 预警类型 */
  alertType?: ERiskWaningType;
  /** 预警状态 */
  alertStatus?: ERiskWaningStatus;
  /** 风险等级 */
  riskLevel?: ERiskWaningLevel;
}

export interface IRiskWarningItem {
  /** 预警ID */
  alertId?: string;
  /** 姓名 */
  personName?: string;
  /** 手机号 */
  phoneNumber?: string;
  /** 身份证号 */
  personIdNumber?: string;
  /** 预警类型 */
  alertType?: ERiskWaningType;
  /** 风险等级 */
  riskLevel?: ERiskWaningLevel;
  /** 预警状态 */
  alertStatus?: ERiskWaningStatus;
  /** 预警生成时间 */
  createTime?: string;
  /** 预警备注 */
  remark?: string;
}

/**
 * 预警业务类型
 */
export enum ERiskWaningBusinessType {
  /** 众包业务 */
  CROWD = 'CROWD',
  /** 撮合业务 */
  MATCH = 'MATCH',
}

export const riskWaningBusinessLabel = {
  [ERiskWaningBusinessType.CROWD]: '众包业务',
  [ERiskWaningBusinessType.MATCH]: '撮合业务',
};

export interface IRiskWarningRecord {
  /** 发放日期 */
  releaseDate?: string;
  /** 子订单号 */
  subOrderNo?: string;
  /** 发放金额 */
  amount?: number;
  /** 业务类型 */
  businessType?: ERiskWaningBusinessType;
  /** 收入性质 */
  incomeType?: EProxyPayType;
  /** 备注 */
  remark?: string;
}

export interface IRiskWarningCompany {
  /** 公司名称 */
  companyName?: string;
  /** 企业统一社会信用代码 */
  creditCode?: string;
  /** 发放次数 */
  releaseCount?: string;
  /** 到账总金额 */
  totalAmount?: string;
  /** 首次发放日期 */
  firstReleaseDate?: string;
  /** 最新发放日期 */
  latestReleaseDate?: string;
}

export interface IRiskWarningLoginCompany {
  /** 公司名称 */
  businessName?: string;
  /** 企业统一社会信用代码 */
  identityCode?: string;
  /** 端类型(SAAS、COMPANY、AGENT、AGENT_PERSON、SERVER),可用值:SAAS,AGENT,PERSON_AGENT,COMPANY,SERVER */
  businessType?: ERiskBusinessType;
  /** 当前用户在此企业下的状态(0停用 1启用) */
  activated?: ERiskActivatedType;
  /** 企业在系统中的状态(0停用 1启用) */
  enable?: ERiskActivatedType;
  /** 当前企业是否在黑名单中(0不在 1在) */
  businessDenyStatus?: ERiskActivatedType;
}

/** 企业在系统中的状态 */
export enum ERiskBusinessType {
  /** 运营端 */
  OPERATION = 'SAAS',
  /** 企业代理商 */
  AGENT = 'AGENT',
  /** 个人代理商 */
  AGENT_PERSON = 'AGENT_PERSON',
  /** 企业端 */
  COMPANY = 'COMPANY',
  /** 服务器端 */
  SERVER = 'SERVER',
}

export const riskBusinessTypeLabel = {
  [ERiskBusinessType.OPERATION]: '运营端',
  [ERiskBusinessType.AGENT]: '企业代理商',
  [ERiskBusinessType.AGENT_PERSON]: '个人代理商',
  [ERiskBusinessType.COMPANY]: '企业端',
  [ERiskBusinessType.SERVER]: '服务器端',
};

/** 当前用户在此企业下的状态 */
export enum ERiskActivatedType {
  /** 停用 */
  Disabled = 0,
  /** 启用 */
  Enabled = 1,
}

export const riskActivatedLabel = {
  [ERiskActivatedType.Disabled]: '已停用',
  [ERiskActivatedType.Enabled]: '已启用',
};

export const riskActivatedStyle = {
  [ERiskActivatedType.Disabled]: 'danger',
  [ERiskActivatedType.Enabled]: 'success',
};

export interface IRiskWarningDetail extends IRiskWarningItem {
  /** 姓名 */
  personName?: string;
  /** 手机号 */
  phoneNumber?: string;
  /** 身份证号 */
  personIdNumber?: string;
  /** 自由职业者编号 */
  customerNo?: string;
  /** 历史预警次数 */
  pastAlertTimes?: number;
  /** 记录列表 */
  recordVOList?: IRiskWarningRecord[];
  /** 公司列表 */
  companyVOList?: IRiskWarningCompany[];
  /** 登录公司列表 */
  loginCompanyVOList?: IRiskWarningLoginCompany[];
}